<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 19.1667H8V12.5H5.33333V19.1667ZM16 19.1667H18.6667V5.83333H16V19.1667ZM10.6667 19.1667H13.3333V15.1667H10.6667V19.1667ZM10.6667 12.5H13.3333V9.83333H10.6667V12.5ZM2.66667 24.5C1.93333 24.5 1.30556 24.2389 0.783333 23.7167C0.261111 23.1944 0 22.5667 0 21.8333V3.16667C0 2.43333 0.261111 1.80556 0.783333 1.28333C1.30556 0.761111 1.93333 0.5 2.66667 0.5H21.3333C22.0667 0.5 22.6944 0.761111 23.2167 1.28333C23.7389 1.80556 24 2.43333 24 3.16667V21.8333C24 22.5667 23.7389 23.1944 23.2167 23.7167C22.6944 24.2389 22.0667 24.5 21.3333 24.5H2.66667ZM2.66667 21.8333H21.3333V3.16667H2.66667V21.8333Z"
      :fill="clr"
    />
  </svg>
</template>
